export const Constants = {
  notifications: 'Notificações',
  noNotifications: 'Não existem notificações no momento',
  entranceDate: 'data de entrada',
  osNumber: ' número OS',
  company: 'empresa',
};
